import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "p-0.5"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = { class: "flex flex-row items-center" };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-angle-down mr-1" }, null, -1);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-folder-open" }, null, -1);
const _hoisted_8 = [
    _hoisted_6,
    _hoisted_7
];
const _hoisted_9 = {
    key: 1,
    class: "cursor-pointer"
};
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-angle-right mr-1" }, null, -1);
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-folder" }, null, -1);
const _hoisted_12 = [
    _hoisted_10,
    _hoisted_11
];
const _hoisted_13 = { key: 1 };
const _hoisted_14 = /*#__PURE__*/ _createTextVNode();
const _hoisted_15 = { class: "px-1" };
const _hoisted_16 = {
    key: 2,
    class: "text-xs text-red-500"
};
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-exclamation-triangle" }, null, -1);
const _hoisted_18 = {
    key: 3,
    class: "text-xs text-red-500"
};
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-exclamation-triangle" }, null, -1);
const _hoisted_20 = {
    key: 4,
    class: "text-xs text-red-500"
};
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-exclamation-triangle" }, null, -1);
const _hoisted_22 = {
    key: 5,
    class: "text-xs flex-grow flex justify-end"
};
const _hoisted_23 = ["onClick"];
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-times text-sm text-red-500 cursor-pointer mr-2" }, null, -1);
const _hoisted_25 = [
    _hoisted_24
];
const _hoisted_26 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_file_tree_view = _resolveComponent("file-tree-view", true);
    return (_ctx.tree && _ctx.tree.length > 0)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedTree, (treeItem, index) => {
                return (_openBlock(), _createElementBlock("li", { key: index }, [
                    _createElementVNode("div", {
                        class: _normalizeClass(["text-gray-500 py-1 border-b", { 'font-bold cursor-pointer select-none text-primary': treeItem.isFolder }]),
                        onClick: _withModifiers(($event) => (_ctx.toggle(treeItem, index)), ["stop"])
                    }, [
                        _createElementVNode("div", _hoisted_3, [
                            (treeItem.isFolder)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                                    (_ctx.isOpen[index])
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _hoisted_8))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_9, _hoisted_12))
                                ]))
                                : _createCommentVNode("", true),
                            (!treeItem.isRoot && !treeItem.isFolder)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_13, "└─"))
                                : _createCommentVNode("", true),
                            _hoisted_14,
                            _createElementVNode("span", _hoisted_15, _toDisplayString(treeItem.name), 1),
                            (!treeItem.isFolder && !treeItem.isValid)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                                    _hoisted_17,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('error.invalidFileType')), 1)
                                ]))
                                : _createCommentVNode("", true),
                            (!treeItem.isFolder && !_ctx.isUnderMaxSize(treeItem.data.size))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                                    _hoisted_19,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('error.fileTooBigError')), 1)
                                ]))
                                : _createCommentVNode("", true),
                            (treeItem.isDuplicate)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                                    _hoisted_21,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('error.duplicateFileError')), 1)
                                ]))
                                : _createCommentVNode("", true),
                            (treeItem.isRoot)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                                    _createElementVNode("span", {
                                        onClick: ($event) => (_ctx.removeItemFromTree(treeItem))
                                    }, _hoisted_25, 8, _hoisted_23)
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ], 10, _hoisted_2),
                    (treeItem.isFolder)
                        ? _withDirectives((_openBlock(), _createElementBlock("ul", _hoisted_26, [
                            _createVNode(_component_file_tree_view, {
                                class: "pl-10",
                                tree: treeItem.children,
                                "onUpdate:tree": ($event) => ((treeItem.children) = $event)
                            }, null, 8, ["tree", "onUpdate:tree"])
                        ], 512)), [
                            [_vShow, _ctx.isOpen[index]]
                        ])
                        : _createCommentVNode("", true)
                ]));
            }), 128))
        ]))
        : _createCommentVNode("", true);
}
